import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parameterSplit'
})
export class ParameterSplitPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    if(value){
      value = value.toLowerCase().trim();
    }else{
      return value;
    }

    var str_array = value.split(',');

    var parameterUnique = [];

    for(var i = 0; i < str_array.length; i++) {
      parameterUnique[str_array[i].trim()] = str_array[i].trim();
    }
    
    return parameterUnique;
  }

}
